
    import I18n from 'i18nObj';
    
      import 'translations/observer_pairing_code';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('observer_pairing_code');
  